import { render, staticRenderFns } from "./workViewer.vue?vue&type=template&id=7a066df6&"
import script from "./workViewer.vue?vue&type=script&lang=js&"
export * from "./workViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports